export const nameValidation =
  "^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\u0400-\u04FF\\s\\-']+$";
